import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../content/ContentContext';
import { getIcon } from '../content/icons';

export default function Schools() {
  const { schools } = useContent();
  const { hero, offers, steps } = schools;

  return (
    <div>
      {/* 页头 */}
      <section className="page-top pb-16 md:pb-24">
        <div className="container-x text-center">
          <div className="eyebrow mb-3 reveal">{hero.eyebrow}</div>
          <h1 className="text-4xl md:text-6xl font-semibold tracking-tight reveal" style={{ color: 'var(--ink)', transitionDelay: '0.05s' }}>
            {hero.title}
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg md:text-xl leading-relaxed reveal" style={{ color: 'var(--muted)', transitionDelay: '0.1s' }}>
            {hero.desc}
          </p>
          <Link to="/contact" className="btn btn-blue mt-10 reveal">索取合作方案</Link>
        </div>
      </section>

      {/* 我们提供什么 */}
      <section className="section-alt py-24 md:py-32">
        <div className="container-x">
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight reveal" style={{ color: 'var(--ink)' }}>{offers.title}</h2>
          <div className="mt-16 grid gap-x-12 gap-y-14 sm:grid-cols-2 lg:grid-cols-3">
            {offers.items.map((o, i) => {
              const Icon = getIcon(o.icon);
              return (
                <div key={i} className="reveal" style={{ transitionDelay: `${(i % 3) * 0.06}s` }}>
                  <Icon className="h-8 w-8" strokeWidth={1.5} style={{ color: 'var(--ink)' }} />
                  <h3 className="mt-5 text-lg font-semibold" style={{ color: 'var(--ink)' }}>{o.title}</h3>
                  <p className="mt-3 text-[15px] leading-relaxed" style={{ color: 'var(--muted)' }}>{o.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* 合作流程 */}
      <section className="py-24 md:py-32">
        <div className="container-x">
          <h2 className="text-center text-3xl md:text-5xl font-semibold tracking-tight reveal" style={{ color: 'var(--ink)' }}>{steps.title}</h2>
          <div className="mx-auto mt-16 max-w-2xl">
            {steps.items.map((s, i) => (
              <div key={i} className="reveal flex gap-6 py-7"
                style={{ borderTop: i === 0 ? 'none' : '1px solid var(--line)', transitionDelay: `${i * 0.06}s` }}>
                <div className="text-2xl font-semibold tabular-nums" style={{ color: 'var(--muted)' }}>{String(i + 1).padStart(2, '0')}</div>
                <div>
                  <h3 className="text-xl font-semibold" style={{ color: 'var(--ink)' }}>{s.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed" style={{ color: 'var(--muted)' }}>{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-alt py-24 md:py-32 text-center">
        <div className="container-x reveal">
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight" style={{ color: 'var(--ink)' }}>为学校定制一套方案</h2>
          <p className="mx-auto mt-5 max-w-xl text-lg" style={{ color: 'var(--muted)' }}>
            留下联系方式，我们的合作顾问会根据学校情况，给出设备配置和课程建议。
          </p>
          <Link to="/contact" className="btn btn-blue mt-10">联系合作顾问</Link>
        </div>
      </section>
    </div>
  );
}